<template>
  <div class="bzc-info bzc-notice-card" :class="'is-' + notice.status" data-test="ask-bizminer-fin-notice">
    <div class="bzc-info-head">
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z"></path></svg>
      <span>{{ notice.title || 'Before you enter your figures' }}</span>
    </div>

    <div v-if="notice.status === 'loading'" class="bzc-info-body">
      <div class="bzc-status" role="status">
        <svg class="bzc-spin" width="15" height="15" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#0a8fc0" stroke-width="3"><path d="M12 3a9 9 0 1 1-9 9"></path></svg>
        Loading&hellip;
      </div>
    </div>

    <div v-else-if="notice.status === 'failed'" class="bzc-info-body">
      <p class="bzc-confirm-error" role="alert" data-test="ask-bizminer-fin-notice-error">{{ notice.error }}</p>
      <button type="button" class="bzc-btn bzc-btn-outline" @click="$emit('reload')">Try again</button>
    </div>

    <div v-else-if="notice.status === 'acked'" class="bzc-info-body">
      <div class="bzc-confirm-done" data-test="ask-bizminer-fin-notice-acked">
        <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true" fill="#2D6731"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
        You agreed. You won't be asked again.
      </div>
      <p v-if="!hasForm" class="bzc-confirm-note">Ask for your report again to go on.</p>
    </div>

    <div v-else class="bzc-info-body">
      <p class="bzc-notice-text" data-test="ask-bizminer-fin-notice-text">{{ notice.text }}</p>
      <p v-if="notice.error" class="bzc-confirm-error" role="alert" data-test="ask-bizminer-fin-notice-error">{{ notice.error }}</p>
      <div class="bzc-notice-actions">
        <button type="button" class="bzc-btn bzc-btn-primary" :disabled="notice.status === 'acking' || busy" data-test="ask-bizminer-fin-notice-continue" @click="$emit('continue')">
          {{ notice.status === 'acking' ? 'Saving…' : label('continue') }}
        </button>
        <a class="bzc-btn bzc-btn-outline" :href="standardPath" data-test="ask-bizminer-fin-notice-standard" @click="$emit('standard', $event, standardPath)">{{ label('standard_form') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
// The financial-data notice (CHAT-11/a, /e). Presentational: the panel owns the
// acknowledgement. All text is cleaned by chatCore.normalizeNotice and drawn as text.
export default {
  name: 'chat-notice-card',
  props: {
    notice: { type: Object, required: true },
    standardPath: { type: String, required: true }, // the app's own report form (CHAT-11/e)
    hasForm: { type: Boolean, default: false }, // a form is waiting behind the notice
    busy: { type: Boolean, default: false },
  },
  methods: {
    label(id) {
      const a = (this.notice.actions || []).find((x) => x.id === id);
      return a ? a.label : id;
    },
  },
};
</script>

<style lang="scss">
.bzc-notice-card.is-acked .bzc-info-head { background: #e4f2e5; color: #1f5a24; }
.bzc-notice-text { font-size: 13.5px; line-height: 1.5; color: #22303f; }
.bzc-notice-actions { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }
@media (max-width: 600px) {
  .bzc-notice-actions { align-items: stretch; }
  .bzc-notice-actions .bzc-btn { align-self: stretch; }
}
</style>
